<template>
  <font-awesome-icon
    icon="file-upload"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFileUpload } from '@fortawesome/free-solid-svg-icons'

library.add(faFileUpload)

export default {
  name: 'CoozzyDocumentIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
  }
</style>
